import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const catalogAdminDataBridgeAccessConfiguration: DomainAccessControlConfig = {
  permissions: Permission.CatalogAdminViewAccess,
}

export const catalogAdminDataBridgeEditAccessConfiguration: DomainAccessControlConfig = {
  permissions: [Permission.CatalogAdminViewAccess, Permission.CatalogAdminModifyAccess],
}
